import { signedInPresenceCookie, signedOutPresenceCookie } from '@featit/shared/presence-cookie';

/**
 * The presence cookie that decides what the deployment's root shows (ADR-133, T-0344): set while
 * this browser holds a session, cleared when it signs out. It is not the session — the token stays
 * in `localStorage` — so writing it can never sign anybody in, and a failure to write it costs only
 * the root: a signed-in reader who opens `/` meets the website and one click back in.
 *
 * `Secure` wherever the page itself is https. A desktop or phone shell's own scheme has no use for
 * it and may refuse a cookie outright, which is why a refusal is swallowed rather than raised.
 */
function write(cookie: (secure: boolean) => string): void {
  if (typeof document === 'undefined') return;
  try {
    document.cookie = cookie(window.location.protocol === 'https:');
  } catch {
    // A shell scheme without cookies: the root is not routed there anyway.
  }
}

/** This browser holds a session: the root shows the app. */
export function markSignedIn(): void {
  write(signedInPresenceCookie);
}

/** This browser signed out: the root shows the website. */
export function markSignedOut(): void {
  write(signedOutPresenceCookie);
}
